import React from 'react';
import HintPopover from "../../../gd-ui/hint-popover/hint-popover";
import {ItemIconClass} from "../../../gd/const/item-icon/icon/item-icon-class";

type Props = {
    className ? : string,
    size?: '12'|'13'|'14'|'15'|'16'|'18',

    taskTypeId?: ID,
    taskType?: any,

    systemStatus?: number,
    priority?: number,
    icon?: string,

    hint?: boolean,

    onClick?: callback
}

export default class TaskTypeIcon extends React.Component<Props> {

    static defaultProps = {
        size: '13',
        hint: false
    };

    getIcon = () => {
        let iconName, specialIcon, typeName;

        if (this.props.taskType) {
            iconName = this.props.taskType.icon;
            typeName = this.props.taskType.name;
        } else if (this.props.icon) {
            iconName = this.props.icon;
        } else if (this.props.taskTypeId) {
            const sessionTaskType = gd.session.taskTypes.get(this.props.taskTypeId);
            if (sessionTaskType) {
                iconName = sessionTaskType.icon;
                typeName = sessionTaskType.name;
            }
            else console.log("WARNING #ldjks08872 TaskIcon: task type not found in session");
        }

        let taskIcon = iconName ? ItemIconClass[iconName] : null;

        if (this.props.systemStatus && gd.const.systemStatus.isClosed(this.props.systemStatus)) {
            specialIcon = <div className="status-icon i5-checkbox-ok"> </div>;
        } else if (this.props.priority) {
            switch(this.props.priority) {
                case gd.const.priority.levels.emergency: taskIcon = "i5-emergency"; break;
                case gd.const.priority.levels.blocker: taskIcon = "i5-flag"; break;

                default:
                    if (this.props.priority > 5) {
                        const priorityStyle = {
                            backgroundColor: '#' + gd.const.priority.colors[this.props.priority]
                        };

                        specialIcon = <div className="priority-icon" style={priorityStyle}> </div>;
                    }
                    break;
            }
        }

        return {icon:taskIcon, specialIcon:specialIcon, typeName:typeName}
    }

    render() {
        const {icon, specialIcon, typeName} = this.getIcon();

        const size = _.get(this.props, 'size', '13')

        const classes = Classes("ui5-ico-"+size, icon, this.props.className, {
            'completed': gd.const.systemStatus.isClosed(this.props.systemStatus)
        });

        return (
            <div className={classes} onClick={this.props.onClick}>
                {specialIcon}
                {this.props.hint && typeName && <HintPopover parent={this} hint={typeName} /> }
            </div>
        );
    }
}
